import api from "src/shared/api";
import { EQueryTagTypes } from "src/shared/types/api";
import { getProvidesTags } from "src/shared/utils/url/query.helpers";
import { IPartnersDocDebtResponse, IPartnersDocDebtParams } from "../types";

export const partnersDocDeptApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPartnersDocDeptList: build.query<
      IPartnersDocDebtResponse,
      IPartnersDocDebtParams
    >({
      query: (params: IPartnersDocDebtParams) => {
        return {
          url: `api/partners/doc-debts`,
          method: "POST",
          body: params,
        };
      },
      providesTags: (response) => {
        const tags = [{ type: EQueryTagTypes.DOCUMENT_DEBT, id: "LIST" }];

        if (!response?.data) return tags;

        const mapped = response.data.map((item) => ({
          id: item.contract?.id ?? "",
        }));

        tags.push(...getProvidesTags(mapped, EQueryTagTypes.DOCUMENT_DEBT));

        return tags;
      },
    }),
    exportPartnersDocDept: build.query<string, IPartnersDocDebtParams>({
      query: (params) => {
        return {
          url: "/api/partners/doc-debts/export",
          method: "POST",
          body: params,
          responseHandler: (response) => response.text(),
        };
      },
    }),
  }),
});

export const {
  useGetPartnersDocDeptListQuery,
  useLazyExportPartnersDocDeptQuery,
} = partnersDocDeptApi;
